import { DestroyRef, Injectable, NgZone } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@examdojo/core/environment';
import posthog from 'posthog-js';
import { filter, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PosthogService {
  constructor(
    private readonly ngZone: NgZone,
    private readonly router: Router,
    private readonly destroyRef: DestroyRef,
  ) {}

  init() {
    if (!PosthogService.canInitPosthog()) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthog.key, {
        api_host: environment.posthog.apiHost,
        person_profiles: 'identified_only',
        capture_pageview: false,
        capture_pageleave: true,
        loaded: (posthogInstance) => {
          this.router.events
            .pipe(
              filter((event) => event instanceof NavigationEnd),
              tap(() => posthogInstance.capture('$pageview')),
              takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
        },
      });
    });
  }

  static canInitPosthog() {
    return !!environment.posthog.key && !!environment.posthog.apiHost;
  }
}
